import commonStrings from 'owa-strings/owa-mini-common-strings';
import mailStrings from 'owa-strings/owa-mini-strings';
import React from 'react';
import { getMailCampaignObjects } from '../util/miniMailCampaignObjects';
import { setCanAllotSpaceForFocusedOtherCampaign } from 'mini-mail-list-store/lib/mutators/setCanAllotSpaceForFocusedOtherCampaign';

const styles = require('./FocusedOtherCampaign.scss');
const FOCUSED_OTHER_IMAGE = require('../images/focusedOthersImage.svg');

/**
 * Component to render the Focused Other embedded message campaign
 */
export const FocusedOtherCampaign = () => {
    const { mailFocusedOthersCampaign } = getMailCampaignObjects();
    return (
        <mailFocusedOthersCampaign.unit
            campaignViewTypeProps={{
                title: mailStrings.focusedOtherEmbeddedMessageTitle,
                subtitle: mailStrings.focusedOtherEmbeddedMessageSubtitle,
                coverImageURL: FOCUSED_OTHER_IMAGE,
                icon: null,
                customClassNames: {
                    componentRoot: styles.campaign,
                    textContainer: styles.textContainer,
                    messageAndImageContainer: styles.messageAndImageContainer,
                },
                anchorProps: {
                    type: 'top',
                    leftInPercent:
                        1200 /
                        (Math.max(window.innerWidth, document.documentElement.clientWidth) - 24),
                },
                onCampaignDismiss: () => setCanAllotSpaceForFocusedOtherCampaign(false), // on pressing close button
                closeButtonAriaLabel: commonStrings.dismissButtonAriaLabel, // on pressing close button
            }}
        />
    );
};
